<template>
  <div class="delay-other">
    <div class="delay" id="delay" ref="delay"></div>
    <div class="delay-box">
      <div class="date">
        <div>
          <span>min</span>
          <span>max</span>
          <span>mvg</span>
          <span>curant*</span>
        </div>
      </div>
      <div class="date-box">
        <div class="left">
          <span style="background:#9ff0ff"></span>
          <span>_delay(ms)</span>
        </div>
        <div class="right">
          <span>{{this.needData._delay.Min}}ms</span>
          <span>{{this.needData._delay.Max}}ms</span>
          <span>{{this.needData._delay.Mvg}}ms</span>
          <span>{{this.needData._delay.Curant}}ms</span>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
export default {
  props:['needData'],
  mounted() {
    // setTimeout(()=>{
    //   this.delay(this.needData);
    // },200)
    this.delay(this.needData);
  },
  // watch: {
  //  'needData'() {
  //     this.delay(this.needData);
  //   },
  // },
  methods: {
    delay(param) {
      let myEchart = this.$echarts.init(document.getElementById("delay"));
    //  console.log(param);
     var date = []; 
      param.DateTime.forEach((item )=> {
        date.push(item.substring(item.length-5));
      });

      let option = {
        grid: {
          top: "12%",
          left: "8%",
          bottom: "26%",
          right: "5%",
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date,
          axisTick: {
            show: false,
          },
          
          splitLine: {
            show: true,
            lineStyle: {
              color: "#526775",
            },
          },
        },
        yAxis: {
          type: "value",
          name: "(ms)",
          nameGap: 10,
          nameTextStyle: {
            padding: [0, 40, 0, 0],
          },
          boundaryGap: [0, "100%"],
          splitLine: {
            show: true,
            lineStyle: {
              color: "#526775",
              type: "dashed",
            },
          },
        },
        series: [
          {
            name: "2020预算",
            type: "line",
            smooth: true,
            stack: "",
            symbol: "none",
            sampling: "average",
            lineStyle: {
              color: "#ffa800",
              width: 1,
            },
            itemStyle: {
              color: "#CA76C4",
              normal: {
                color: "#ffa800",
                lineStyle: {
                  color: "#ffa800",
                  width: 1,
                },
                areaStyle: {
                  //color: '#94C9EC'
                  color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                    {
                      offset: 0,
                      color: "rgba(255,168,0,0)",
                    },
                    {
                      offset: 1,
                      color: "rgba(255,168,0,0.8)",
                    },
                  ]),
                },
              },
              markPoint: {
                itemStyle: {
                  normal: {
                    color: "red",
                  },
                },
              },
            },
            data: param.Data1,
          },
        ],
      };
      myEchart.setOption(option);
      window.addEventListener("resize", () => {
        myEchart.resize();
      });
    },
  },
};
</script>

<style scoped>
.delay-other {
  width: 100%;
  height: 100%;
  position: relative;
}
.delay {
  width: 100%;
  height: 100%;
}

.delay-box {
  width: 95%;
  height: 4.6vh;
  position: absolute;
  bottom: 0;
  left: 3%;
  
}
.delay-box .date {
  width: 100%;
  height: 1.6vh;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #00e4ff;
  font-size: 0.6vw;
}

.delay-box .date div {
  width: 50%;
  height: 100%;
  align-items: center;
  justify-content: space-around;
}
.delay-box .date div span {
  height: 100%;
  margin-right: 1.5vw;
  transform: scale(0.7);
  line-height: 1vh;
}

.delay-box .date-box {
  width: 100%;
  height: 2.3vh;
  background: url('../../assets/img/74.png');
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: .6vw;
  margin-bottom: .5vh;
}

.delay-box .date-box .left {
  width: 17%;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 0.6vw;
  justify-content: space-between;
  margin-left:1vw;
}

.delay-box .date-box .left span:nth-child(1) {
  width: 1.45vw;
  height: .7vh;
  background: red;
}
.delay-box .date-box .left span:nth-child(2) {
  color: #aebfc4;
}

.delay-box .date-box .right {
  width: 39%;
  display: flex;
  align-items: center;
  color: #aebfc4;
  margin-right: 2vw;
}
.delay-box .date-box .right span {
  margin-left: .6vw;
}

.delay-box .date-box .right span:nth-child(1) {
  margin-left: 0;
}


</style>


